import { FC } from "react";
import useImport from "../hooks/useImport";
import useMagento from "../hooks/useMagento";
import Page from "../layout/Main/Page";

const DashboardPage: FC = () => {
  const { getCategories } = useMagento();


  return (
    <Page header={{
      title:  `New Import`,
      subTitle: 'Add new products import task',
    }}>
      Dashboard
    </Page>
  );
}

export default DashboardPage;
